module.exports = __webpack_public_path__ + "img/close.d4884073.svg";